'use client';
import cx from 'classnames';
import useSearchBarVisibility from '../../../hooks/use-search-bar-visibility/use-search-bar-visiblity';

export const SearchWidgetWrapper = ({
  isSearchBarInHeader,
  children
}: {
  isSearchBarInHeader: boolean;
  children: React.ReactNode;
}) => {
  const { isSearchVisible } = useSearchBarVisibility(isSearchBarInHeader);

  return (
    <div
      className={isSearchVisible ? cx('d-flex', 'flex-grow-1') : cx('d-none')}
    >
      {children}
    </div>
  );
};
